import TKProductTile from '@tk/components/tk.product.tile';

export default class DIWProductTile extends TKProductTile {
    productVariantsRadio: NodeListOf<HTMLInputElement>;

    constructor() {
        super();
        this.productVariantsRadio = this.querySelectorAll('[data-tk-product-variants]');
    }

    connectedCallback(): void {
        super.connectedCallback();
    }

    protected registerListener(): void {
        if (this.productVariantsRadio.length === 0) return;
        const handleRadioChange = this.handleRadioChange.bind(this);

        [...this.productVariantsRadio].forEach((radio) => {
            this.pushListener({
                event: 'change',
                element: radio,
                action: handleRadioChange,
            });
        });
    }

    protected handleRadioChange(e: Event): void {
        const radio = e.target as HTMLInputElement;
        if (radio.checked) {
            this.getProductVariant(radio.value);
        }
    }
}
